import {
  AcademyAction,
  AcademyState,
  participantTypes,
} from './academy.types'

// Reducer actions
export const ACADEMY_ACTIONS = {
  SET_ACADEMY_EVENTS: 'SET_ACADEMY_EVENTS',
  SET_FILTERED_LIST: 'SET_FILTERED_LIST',
  SET_VERIFIED_CLUBS: 'SET_VERIFIED_CLUBS',
  SET_SELECTS: 'SET_SELECTS',
  SET_PARTICIPANT_SELECT: 'SET_PARTICIPANT_SELECT',
  SET_DROPDOWN_LISTS: 'SET_DROPDOWN_LISTS',
  SET_LOADING: 'SET_LOADING',
  SET_VERIFIED_LOADING: 'SET_VERIFIED_LOADING',
  RESET_FILTERS: 'RESET_FILTERS',
} as const

export const createInitialState = (urlFilters?: {
  participant?: string | null
  month?: string | null
  state?: string | null
  training?: string | null
}): AcademyState => {
  const participantStr =
    participantTypes.find((p) => p.value === urlFilters?.participant)?.value ??
    participantTypes[0].value
  return {
    academyEvents: [],
    filteredList: [],
    verifiedClubs: [],
    selects: {
      participant: participantStr,
      month: urlFilters?.month ?? 'By Month',
      state: urlFilters?.state ?? 'All Locations',
      training: urlFilters?.training ?? 'All Training',
    },
    dropdownLists: {
      states: [],
      months: [],
      trainings: [],
    },
    loading: true,
    verifiedLoading: true,
  }
}

export const academyReducer = (
  state: AcademyState,
  action: AcademyAction
): AcademyState => {
  switch (action.type) {
    case ACADEMY_ACTIONS.SET_ACADEMY_EVENTS:
      return { ...state, academyEvents: action.payload }

    case ACADEMY_ACTIONS.SET_FILTERED_LIST:
      return { ...state, filteredList: action.payload }

    case ACADEMY_ACTIONS.SET_VERIFIED_CLUBS:
      return { ...state, verifiedClubs: action.payload }

    case ACADEMY_ACTIONS.SET_SELECTS:
      return {
        ...state,
        selects: { ...state.selects, ...action.payload },
      }

    case ACADEMY_ACTIONS.SET_PARTICIPANT_SELECT:
      return {
        ...state,
        selects: { ...state.selects, participant: action.payload.value },
      }

    case ACADEMY_ACTIONS.SET_DROPDOWN_LISTS:
      return {
        ...state,
        dropdownLists: { ...state.dropdownLists, ...action.payload },
      }

    case ACADEMY_ACTIONS.SET_LOADING:
      return { ...state, loading: action.payload }

    case ACADEMY_ACTIONS.SET_VERIFIED_LOADING:
      return { ...state, verifiedLoading: action.payload }

    case ACADEMY_ACTIONS.RESET_FILTERS:
      return {
        ...state,
        selects: {
          participant: state.selects.participant,
          month: 'By Month',
          state: 'All Locations',
          training: 'All Training',
        },
      }

    default:
      return state
  }
}
